<template>                    
    
    <v-layout row>
        <v-flex xs12>
            <v-select                        
                label="Auswahl Types"                                
                dark              
                cache-items
                required
                v-bind:items="types"     
                item-text="name"
                item-value="id"
                return-object
                v-model="type"></v-select>
        </v-flex>

        
    </v-layout>
       

</template>

<script>

export default {
    
    data() {
        return {           
            type:null
            
        };
    },
    
    /*created: function(){
        this.$store.dispatch('setTypes')
    },*/
    computed: {
        types: function() {
            
            return this.$store.getters.types
        },
       
        loading: function() {
            return this.$store.getters.loading
        }
    },
    methods: {
        
              
    }
}
    
</script>

<style>
    
    
    
</style>


// WEBPACK FOOTER //
// typesSelectSingle.vue?206262cc